<template>
  <div class="loadingSection bg-white">
    <div class="bg-white-cover"></div>
    <div class="loading-screen">
      <div class="loading-indicator" :class="{'spin': isLoading}">
        <img src="/img/adt.svg" alt="">
      </div>
      <div class="loading-title">{{ title }}</div>
      <transition name="fade">
        <div class="loading-subtitle" v-if="systemReady">Let’s cover some basics</div>
      </transition>
      <transition name="fade">
        <continue-button v-if="systemReady" :to="to" />
      </transition>
      <div class="loading-steps">
        <!-- LOADING STEP -->
        <div v-for="step in steps" class="loading-step" :class="{'text-bold': step.status !== 'incomplete', 'loading': step.status === 'loading'}">
          <div class="loading-step-content">
            <transition name="fade">
              <img class="loading-checkmark" src="/img/checkmark.png" alt="Checkmark" v-if="step.status === 'complete'" />
            </transition>
            {{ stepText(step) }}
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  data() {
    return {
      isLoading: false,
      loadingLength: 1150,
      steps: [
        // Step 1
        {
          text: 'Reviewing home assessment',
          status: 'incomplete' // incomplete, loading, complete
        },

        // Step 2
        {
          text: 'Determining correct monitoring plan',
          status: 'incomplete'
        },

        // Step 3
        {
          text: 'Looking for discounts',
          status: 'incomplete'
        },

        // Step 4
        {
          text: 'Applying discounts and promotional code',
          status: 'incomplete'
        }
      ]
    }
  },
  computed: {
    ...mapState(['user']),

    title() {
      return this.systemReady ? "We're all done!" : 'One moment...'
    },

    to() {
      return this.user.name ? '/assessment/monitoring-overview' : '/assessment/register'
    },

    systemReady() {
      let steps = this.steps
      let stepsCount = this.steps.length
      let stepsComplete = this.steps.filter((step) => step.status === 'complete')
      let stepsCompleteCount = stepsComplete.length

      if (stepsCount === stepsCompleteCount) {
        return true
      }

      return false
    },

  },
  methods: {
    ...mapActions(['updateSystem']),

    stepText(step) {
      if (step.status === 'loading') {
        return `${step.text}...`
      }
      return step.text
    },

    load(stepIndex) {
      let animationDuration = 1600
      setTimeout(() => {
        this.isLoading = true
        this.steps[stepIndex].status = 'loading'
        setTimeout(() => { this.isLoading = false }, 750)
        setTimeout(() => { 
          this.steps[stepIndex].status = 'complete' 
          if (stepIndex === this.steps.length - 1) {
            setTimeout(() => this.$router.push(this.to), 300)
          }
        }, 750)
        
      }, stepIndex * animationDuration)
    },
  },
  mounted () {
    gtag('event', 'conversion', {'send_to': 'AW-879819493/mQfpCM-24nsQ5fXDowM'});
    // this.updateSystem()
    setTimeout(() => {
      this.load(0)
      this.load(1)
      this.load(2)
      this.load(3)
      this.load(4)
    }, 0)
    
  }
}
</script>

<style lang="css">
</style>
